import { compose, withProps, withState, withHandlers, lifecycle } from "recompose";
import numeral from "numeral";
import { withUserLockedFeatures } from "./withUserUnlockFeatures";
import { withCustomizeTopNine } from "./withCustomizeGrid";
import { withUserFetch } from "./withUser";
import { withUserCountry } from "./withUserCountry";
import { withPaymentRequest } from "./withPaymentRequest";

const NUMBER_FORMAT = "[0][0][0].[0]a";

export const withGridStats = compose(
  withHandlers({
    leadingZeros: () => stringNumber => stringNumber.replace(/^0+(?!\.|$)/, ""),
  }),
  withProps(props => {
    const { stats, posts } = props.source || {
      stats: {
        likes: 0,
        count: 0,
      },
      posts: [],
    };
    return {
      likes: stats ? props.leadingZeros(numeral(stats.likes).format(NUMBER_FORMAT)) : 0,
      likesPerPost: stats
        ? props.leadingZeros(numeral(Math.round(stats.likes / stats.count)).format(NUMBER_FORMAT))
        : 0,
      totalPost: stats ? stats.count : 0,
      isLoading: props.isFetching,
      items: posts,
      ...(props.source || {}),
    };
  })
);

export const withTopNine = compose(
  withState("isFetching", "setIsFetching", true),
  withState("source", "setSource", null),
  withState("error", "setError", null),
  withState("checkoutStatus", "setCheckoutStatus", ""), // for UNLOCK TOP NINE WEB
  withState("checkoutWatermarkStatus", "setCheckoutWatermarkStatus", ""),
  withState("checkout", "setCheckout", {}),
  withState("openBlockingModal", "setOpenBlockingModal", false),
  withState("gridDelayReady", "setGridDelayReady", false),
  withCustomizeTopNine,
  withUserFetch,
  withGridStats,
  withUserCountry,
  withUserLockedFeatures,
  withPaymentRequest,
  withProps(props => ({
    lockedWatermark: props.source && props.source.withWatermark && props.checkoutWatermarkStatus !== "success",
  })),
  withProps(props => ({
    storyUrl:
      props.stories && props.stories[props.storyCustomizationKey]
        ? props.lockedWatermark
          ? props.stories[props.storyCustomizationKey].storyUrlWithWatermark
          : props.stories[props.storyCustomizationKey].storyUrl
        : undefined,
  })),
  withHandlers({
    onCheckoutStatusChange: props => status => {
      props.setCheckoutStatus(status);
    },
    onCheckoutWatermarkStatusChange: props => status => {
      props.setCheckoutWatermarkStatus(status);
    },
  }),
  lifecycle({
    componentDidMount() {
      if (window.gtag && (!this.props.items || this.props.items.length == 0)) {
        window.gtag("event", "page_view", { title: "Top Nine Grid Loading" });
      }
    },
    componentWillReceiveProps(nextProps) {
      if (
        nextProps.items &&
        nextProps.items.length > 0 &&
        (!this.props.items ||
          this.props.items.length == 0 ||
          (nextProps.showBlockingModalInGrid && !this.props.showBlockingModalInGrid))
      ) {
        const exceptionForPaymentButton =
          nextProps.exceptionsWithPaymentButton && nextProps.canMakePaymentWithButton;

        const gridWithDelay = nextProps.gridDelay && nextProps.gridDelay != 0 && !exceptionForPaymentButton;
        if (gridWithDelay) {
          setTimeout(() => {
            nextProps.setGridDelayReady(true);
          }, nextProps.gridDelay);
        } else {
          nextProps.setGridDelayReady(true);
        }

        if (window.gtag) {
          window.gtag("event", "page_view", { title: "Top Nine Grid Completed" });
        }
        if (nextProps.showBlockingModalInGrid && !exceptionForPaymentButton) {
          const MODAL_DELAY = 4000;
          setTimeout(
            () => {
              if (window.gtag) window.gtag("event", "show_grid_blocking_modal");
              nextProps.setOpenBlockingModal(true);
            },
            gridWithDelay ? nextProps.gridDelay + MODAL_DELAY : MODAL_DELAY
          );
        }
      }
    },
  })
);

export default withTopNine;
